import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useMemo } from 'react';
import scrollTo from 'commons/scrollTo';
import poll from 'commons/poll';
import isClient from 'commons/isClient';
import { times } from 'lodash';
import useIsBrowser from 'hooks/useIsBrowser';
const useProductListingRestoreScrollPosition = t0 => {
  const $ = _c(23);
  const {
    isLoadingComplete,
    loadAllProducts,
    loadMoreProducts,
    previousLastProductPath,
    previousLoadMoreClickCount,
    previousScrollPosition,
    setHasScrollPositionBeenRestored,
    skip: t1,
    action
  } = t0;
  const skip = t1 === undefined ? false : t1;
  const isBrowser = useIsBrowser();
  let t2;
  if ($[0] !== isBrowser || $[1] !== previousLastProductPath) {
    t2 = isBrowser && !!document.querySelector(`[data-xc='product-grid'] [href^='${previousLastProductPath}']`);
    $[0] = isBrowser;
    $[1] = previousLastProductPath;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const hasPreviousLastProductPathElement = t2;
  let t3;
  if ($[3] !== action || $[4] !== hasPreviousLastProductPathElement || $[5] !== loadAllProducts || $[6] !== loadMoreProducts || $[7] !== previousLastProductPath || $[8] !== previousLoadMoreClickCount || $[9] !== previousScrollPosition || $[10] !== setHasScrollPositionBeenRestored) {
    t3 = () => {
      const shouldShowAllProducts = previousLoadMoreClickCount === -1;
      if (shouldShowAllProducts) {
        loadAllProducts();
      } else {
        if (previousLoadMoreClickCount > 0) {
          times(previousLoadMoreClickCount, loadMoreProducts);
        }
      }
      if (previousScrollPosition > 0) {
        poll({
          condition: () => isClient() && !!previousLastProductPath && hasPreviousLastProductPathElement && action !== "PUSH",
          interval: 25,
          maxRetries: shouldShowAllProducts ? 400 : 100,
          callback: () => {
            scrollTo({
              top: previousScrollPosition,
              behavior: "smooth"
            });
            setHasScrollPositionBeenRestored(true);
          }
        });
      }
    };
    $[3] = action;
    $[4] = hasPreviousLastProductPathElement;
    $[5] = loadAllProducts;
    $[6] = loadMoreProducts;
    $[7] = previousLastProductPath;
    $[8] = previousLoadMoreClickCount;
    $[9] = previousScrollPosition;
    $[10] = setHasScrollPositionBeenRestored;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const restoreScrollPosition = t3;
  let t4;
  if ($[12] !== isLoadingComplete || $[13] !== restoreScrollPosition || $[14] !== setHasScrollPositionBeenRestored || $[15] !== skip) {
    t4 = () => {
      if (skip) {
        return;
      }
      if (isLoadingComplete) {
        restoreScrollPosition();
      } else {
        setHasScrollPositionBeenRestored(false);
      }
    };
    $[12] = isLoadingComplete;
    $[13] = restoreScrollPosition;
    $[14] = setHasScrollPositionBeenRestored;
    $[15] = skip;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== hasPreviousLastProductPathElement || $[18] !== isLoadingComplete || $[19] !== restoreScrollPosition || $[20] !== setHasScrollPositionBeenRestored || $[21] !== skip) {
    t5 = [isLoadingComplete, restoreScrollPosition, setHasScrollPositionBeenRestored, hasPreviousLastProductPathElement, skip];
    $[17] = hasPreviousLastProductPathElement;
    $[18] = isLoadingComplete;
    $[19] = restoreScrollPosition;
    $[20] = setHasScrollPositionBeenRestored;
    $[21] = skip;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  useEffect(t4, t5);
};
export default useProductListingRestoreScrollPosition;